import Tabs, { Tab } from '@/components/ui/tabs';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useEffect, useState } from 'react';
import { useAdminStore } from '../../store/useAdmin.store';
import { useLocation, useNavigate } from 'react-router-dom';

export enum AdminTabsEnum {
  SchoolManagement = 'school-management',
  SchoolDashboard = 'dashboard',
  ManageStaff = 'manage-users',
  SurveyDashboard = 'survey-dashboard',
  Announcements = 'announcements',
}

export const AdminTabs = () => {
  const activeTab = useLocation().pathname.split('/').pop() as AdminTabsEnum;
  const { authentication } = useAuthentication();
  const { page } = useAdminStore();
  const navigate = useNavigate();

  const [tabs, setTabs] = useState<Tab[]>([
    {
      name: page?.schoolManagement.tabs?.adminManagementTabName || 'Admin Management',
      href: '/school-management',
      current: activeTab === AdminTabsEnum.SchoolManagement,
    },
    {
      name: page?.schoolManagement.tabs?.reportingDashboardTabName || 'Reporting Dashboard',
      href: '/dashboard',
      current: activeTab === AdminTabsEnum.SchoolDashboard,
    },
    {
      name: page?.schoolManagement.tabs?.surveyDashboardTabName || 'Survey Dashboard',
      href: '/survey-dashboard',
      onClick: () => {},
      current: activeTab === AdminTabsEnum.SurveyDashboard,
    },
    {
      name: page?.schoolManagement.tabs?.announcementsTabName || 'Announcements',
      href: '/announcements',
      onClick: () => {},
      current: activeTab === AdminTabsEnum.Announcements,
    },
    {
      name: page?.schoolManagement.tabs?.manageStaffTabName || 'Manage Staff',
      href: '/manage-users',
      onClick: () => {},
      current: activeTab === AdminTabsEnum.ManageStaff,
    },
  ]);

  useEffect(() => {
    if (!authentication || !authentication.user) {
      return;
    }

    if (!authentication.user.ws_permission) {
      return navigate('/not-authorized');
    }

    if (!authentication.user.ws_permission.adminManagement) {
      tabs.splice(0, 1);
    }
    if (!authentication.user.ws_permission.reportingDashboard) {
      tabs.splice(1, 1);
    }
    if (!authentication.user.ws_permission.surveyDashboard) {
      tabs.splice(2, 1);
    }
    if (!authentication.user.ws_permission.announcements) {
      tabs.splice(3, 1);
    }

    if (!authentication.user.ws_permission.userManagement) {
      tabs.splice(4, 1);
    }
    setTabs([...tabs]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authentication]);
  return (
    <div className=" flex w-full justify-center">
      <Tabs tabs={tabs} setTabs={() => {}} />
    </div>
  );
};
